export function directoryRoleLabel(role: string | undefined | null): string {
  if (!role) return "-";
  if (role === "account_owner") return "Organization Owner";
  return role
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function directoryDisplayName(user: {
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  id?: string;
}): string {
  const fromName = user.name?.trim();
  if (fromName) return fromName;
  const fromParts = `${user.firstName || ""} ${user.lastName || ""}`.trim();
  if (fromParts) return fromParts;
  return user.email?.trim() || user.id?.trim() || "User";
}
